/** @format */

import React, { useState, useEffect } from "react";
import {
  applySortFilter,
  getComparator,
} from "../../reusables/table/SortFilterUtils";
import Page from "../../components/Page";
import {
  Button,
  Card,
  Container,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
  Typography,
  CircularProgress,
} from "@mui/material";
// import { useNavigate } from "react-router-dom";
import Iconify from "../../components/Iconify";
import SearchToolbar from "../../reusables/table/SearchToolbar";
import Scrollbar from "../../components/Scrollbar";
import SortableTableHeader from "../../reusables/table/SortableTableHeader";
// import NumberMoreMenu from "../number/NumberMoreMenu";
// import SearchNotFound from "../../components/SearchNotFound";
// import TableMenuDropdown from "../../reusables/table/TableMenuDropdown";
// import TableMenuItem from "../../reusables/table/TableMenuItem";
// import MessageTemplate from "src/dao/MessageTemplate";
// import Select from "react-select";
import Waba from "../../dao/Waba";
import CreateWabaDialog from "./CreateWabaDialog";
import UpdateWabaDialog from "./UpdateWabaDialog";
import swal from "../../reusables/CustomSwal";
import { useSelector } from "react-redux";

const TABLE_HEAD = [
  { id: "id", sortable: false },
  { id: "waba_id", label: "WABA ID", alignRight: false, sortable: true },
  { id: "name", label: "Name", alignRight: false, sortable: true },
  { id: "industry", label: "Industry", alignRight: false, sortable: true },
  { id: "website", label: "Website", alignRight: false, sortable: true },
  { id: "action", label: "", alignRight: false, sortable: false },
];

export default function WabaMasterList() {
  let user = useSelector(({ auth }) => auth.auth);
  const [addingWaba, setAddingWaba] = useState(false);
  const [updateWaba, setUpdateWaba] = useState(false);

  const [page, setPage] = useState(0);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("waba_id");
  const [filterName, setFilterName] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isDataFetched, setIsDataFetched] = useState(false);

  const [wabas, setWabas] = useState([]);
  const [details, setDetails] = useState([]);

  // const navigate = useNavigate();

  const getWabas = async () => {
    try {
      let result = await Waba.getMyWaba();
      // console.log(result);
      setWabas(result);
      setIsDataFetched(true);
    } catch (e) {
      // nothing
      console.log(e);
      setIsDataFetched(true);
    }
  };

  useEffect(() => {
    getWabas();
  }, []);

  let count = page * rowsPerPage + 1;

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    count = page * rowsPerPage + 1;
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - wabas.length) : 0;
  const filteredData = applySortFilter(
    wabas,
    getComparator(order, orderBy),
    filterName,
    "waba_id"
  );
  // const filteredData = wabas
  const notFound = filteredData.length === 0;

  return (
    <Page title="WABA Master">
      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            WABA Master
          </Typography>
          <Stack direction="row" spacing={3}>
            {/*<Button*/}
            {/*  variant="outlined"*/}
            {/*  component={RouterLink}*/}
            {/*  to="#"*/}
            {/*  startIcon={<Iconify icon="akar-icons:gear"/>}*/}
            {/*>*/}
            {/*  Namespace*/}
            {/*</Button>*/}

            {user.role === "SUPER_ADMIN" && (
              <>
                <Button
                  variant="outlined"
                  onClick={() => {
                    console.log("here refresh data");
                  }}
                >
                  Refresh Data
                </Button>
                <Button
                  variant="contained"
                  onClick={() => {
                    setAddingWaba(true);
                  }}
                  startIcon={<Iconify icon="akar-icons:plus" />}
                >
                  New WABA Master
                </Button>
              </>
            )}
          </Stack>
        </Stack>

        <Card>
          <SearchToolbar
            filterName={filterName}
            onFilterName={handleFilterByName}
          />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table style={{ backgroundColor: "white", color: "white" }}>
                <SortableTableHeader
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  onRequestSort={handleRequestSort}
                />
                <TableBody>
                  {filteredData
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, key) => {
                      const { waba_id, name, industry, website } = row;

                      return (
                        <TableRow hover key={key} tabIndex={-1} role="checkbox">
                          <TableCell align="left">{count++}</TableCell>
                          <TableCell align="left">{waba_id}</TableCell>
                          <TableCell align="left">{name}</TableCell>
                          <TableCell align="left">{industry}</TableCell>
                          <TableCell align="left">{website}</TableCell>
                          <TableCell align="right">
                            <Button
                              onClick={() => {
                                setUpdateWaba(true);
                                setDetails(row);
                              }}
                            >
                              Edit
                            </Button>

                            <Button
                              onClick={async () => {
                                let popupResult = await swal.fire({
                                  title: "Confirm",
                                  text: "Are you sure to delete this WABA?",
                                  icon: "question",
                                  showConfirmButton: true,
                                  showCancelButton: true,
                                  confirmButtonText: "Yes",
                                });

                                if (popupResult.isConfirmed) {
                                  try {
                                    await Waba.deleteWaba(waba_id);

                                    await swal.fire({
                                      title: "Success",
                                      text: "Waba has been deleted",
                                      icon: "success",
                                      showConfirmButton: true,
                                    });

                                    getWabas();
                                  } catch (e) {
                                    await swal.fire({
                                      title: "Error",
                                      text: "An Error Occured",
                                      icon: "Error",
                                      showConfirmButton: true,
                                    });
                                    getWabas();
                                  }
                                }
                              }}
                            >
                              Delete
                            </Button>
                          </TableCell>
                        </TableRow>
                      );
                    })}

                  {emptyRows > 0 && (
                    <TableRow style={{ height: 69 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>
                {(notFound || !isDataFetched) && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        {!isDataFetched ? (
                          <CircularProgress />
                        ) : (
                          <>Data is not found</>
                        )}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[10, 20, 50, 100]}
            component="div"
            count={wabas.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            xonRowsPerPsageChange={handleChangeRowsPerPage}
          />
        </Card>

        <CreateWabaDialog
          open={addingWaba}
          onClose={(refresh) => {
            console.log();
            setAddingWaba(false);
            if (refresh) {
              getWabas();
            }
          }}
        />

        <UpdateWabaDialog
          details={details}
          open={updateWaba}
          onClose={(refresh) => {
            setUpdateWaba(false);
            if (refresh) {
              getWabas();
            }
          }}
        />
      </Container>
    </Page>
  );
}
